import { type BusinessSubscription } from "lens-platform-sdk";

/**
 * Trim business subscription uuid into "first 6 chars ...last 6 chars"
 */
export const trimSubscriptionId = (subscriptionId?: BusinessSubscription["id"]) => {
  const length = subscriptionId?.length ?? 0;

  if (length > 13) {
    return `${subscriptionId?.substring(0, 6)}...${subscriptionId?.substring(length - 6, length)}`;
  }

  return subscriptionId ?? "";
};
